import { render, staticRenderFns } from "./solid-button.vue?vue&type=template&id=442301d1&scoped=true&"
import script from "./solid-button.vue?vue&type=script&lang=ts&"
export * from "./solid-button.vue?vue&type=script&lang=ts&"
import style0 from "./solid-button.vue?vue&type=style&index=0&id=442301d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442301d1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
